import React from 'react';
import { Layout, Row, Col } from 'antd';
import MediaQuery from 'react-responsive';

export default ({ header, children }) => {
  const widgetGroups = (size) => {
    return children.reduce((memo, widget) => {
      if(!memo[widget.props.position[size]]) {
        memo[widget.props.position[size]] = [];
      }
      memo[widget.props.position[size]].push(widget);
      return memo;
    }, []);
  };

  const widgets = (size) => {
    return (
      widgetGroups(size).map((group, groupIndex) => {
        return (
          <Row key={groupIndex} className="widget-column">
            {
              group.map((widget, index) => {
                return (
                  <div key={index} className="statistics-page-widget">
                    {widget}
                  </div>
                )
              })
            }
          </Row>
        )
      })
    )
  };

  return (
    <Layout className="dashboard-layout__content m-24">
      {header}
      <div className="statistics-page-widget-container">
        <MediaQuery minWidth={1600}>{widgets('xl')}</MediaQuery>
        <MediaQuery minWidth={769} maxWidth={1599}>{widgets('lg')}</MediaQuery>
        <MediaQuery minWidth={0} maxWidth={768}>{widgets('md')}</MediaQuery>
      </div>
    </Layout>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgetContainer.js